import { styled } from "goober";
import { useEffect, useRef, useState } from "react";
import introVideoPoster from "../assets/video/new-user-intro-poster.png";
import introVideo from "../assets/video/new-user-intro.mp4";
import { trackVideoEvent } from "../lib/tracing";
import { Modal } from "./Modal";

const SIGNUP_FLOW_STORAGE_KEY = "3b-new-user-from-signup-flow";
const VIDEO_NAME = "new-user-intro";

function cameFromSignupFlow(): boolean {
  if (typeof localStorage === "undefined") return false;
  return localStorage.getItem(SIGNUP_FLOW_STORAGE_KEY) !== null;
}

export function markCameFromSignupFlow(): void {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(SIGNUP_FLOW_STORAGE_KEY, "true");
}

const VideoFrame = styled("div")`
  width: min(80vw, 800px);
  aspect-ratio: 16 / 9;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 16px;
  background: var(--surface-secondary);

  & video {
    width: 100%;
    height: 100%;
    border: 0;
  }
`;

export function NewUserIntroVideo() {
  const [eligible] = useState(cameFromSignupFlow);
  const [open, setOpen] = useState(false);
  const hasShown = useRef(false);

  useEffect(() => {
    if (hasShown.current || !eligible) return;
    hasShown.current = true;
    localStorage.removeItem(SIGNUP_FLOW_STORAGE_KEY);
    setOpen(true);
  }, [eligible]);

  if (!open) return null;

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <VideoFrame>
        <video
          src={introVideo}
          poster={introVideoPoster}
          controls
          playsInline
          preload="metadata"
          onPlay={() => trackVideoEvent(VIDEO_NAME, "play")}
          onPause={() => trackVideoEvent(VIDEO_NAME, "pause")}
          onEnded={() => trackVideoEvent(VIDEO_NAME, "ended")}
        />
      </VideoFrame>
    </Modal>
  );
}
